export default __webpack_public_path__ + "/dist/images/fda-bg.5e0bcf29ba5fc00f055a1d43e35faeb1.svg";